var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[(_vm.user)?[_c('el-scrollbar',{staticClass:"main-container",attrs:{"viewClass":"main-container-scrollbar-view","wrap-class":"main-container-scrollbar-wrapper"}},[_c('navbar',{staticClass:"main-navbar"}),_c('div',{staticClass:"app-main"},[_c('router-view',{key:_vm.key})],1)],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }